import { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { syncWishlist, toggleWishlist } from "../feature/wishlist";

// Guests: wishlist works from localStorage (no login needed).
// Logged-in users: guest items are merged into MySQL once, then the DB list is used.
export default function useWishlist() {
  const dispatch = useDispatch();
  const items = useSelector((state) => state.wishlist.items);

  useEffect(() => {
    if (localStorage.getItem("token")) dispatch(syncWishlist());
  }, [dispatch]);

  const toggle = useCallback((product) => dispatch(toggleWishlist(product)), [dispatch]);

  return { items, toggle };
}
